import { http } from '@/lib/http';

const BASE = '/api/v1/request-reasons';

export type RequestReasonScope = 'RETURN' | 'EXCHANGE' | 'CANCEL';

export interface RequestReason {
  id: string;
  tenantId: string;
  code: string;
  label: string;
  appliesTo: RequestReasonScope[];
  autoApproveFor: RequestReasonScope[];
  requiresPhotos: boolean;
  requiresComment: boolean;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRequestReasonPayload {
  code: string;
  label: string;
  appliesTo: RequestReasonScope[];
  autoApproveFor?: RequestReasonScope[];
  requiresPhotos?: boolean;
  requiresComment?: boolean;
  isActive?: boolean;
  sortOrder?: number;
}

export type UpdateRequestReasonPayload = Partial<
  Omit<CreateRequestReasonPayload, 'code'>
>;

export const requestReasonsService = {
  list: () => http.get<RequestReason[]>(BASE),
  create: (payload: CreateRequestReasonPayload) =>
    http.post<RequestReason, CreateRequestReasonPayload>(BASE, payload),
  update: (id: string, payload: UpdateRequestReasonPayload) =>
    http.patch<RequestReason, UpdateRequestReasonPayload>(`${BASE}/${id}`, payload),
};
